/* eslint-disable prettier/prettier */
import React from 'react';
import styles from '../../styles/layout/DashboardHeader.module.css';
import { useHeader } from '../../context/HeaderContext';
import { useUserProfile } from '../../hooks/useUserProfile';

// Import the new icons
import { ReactComponent as SearchIcon } from '../../assets/icons/search.svg';
import { ReactComponent as BellIcon } from '../../assets/icons/notification.svg';
import { ReactComponent as MailIcon } from '../../assets/icons/message.svg';
import { ReactComponent as HelpIcon } from '../../assets/icons/help.svg';
import iocmLogo from '../../assets/images/IOCM_logo.png';
import { useLocation, useNavigate } from 'react-router-dom';
import LogoutConfirmModal from '../controlVariations/LogoutConfirmModal';
import iconlogout from '../../assets/profile/finallog.png';
import { useAuth } from '../../hooks/useAuth';

// Simple Hamburger SVG Component
const MenuIcon = () => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M3 12H21"
			stroke="#1E1E1E"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M3 6H21"
			stroke="#1E1E1E"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M3 18H21"
			stroke="#1E1E1E"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

interface DashboardHeaderProps {
	onMenuClick?: () => void;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({ onMenuClick }) => {
	const { headerContent, isOverridden } = useHeader();
	const { profile } = useUserProfile();
	const { logout } = useAuth();
	const navigate = useNavigate();

	const [showLogoutConfirm, setShowLogoutConfirm] = React.useState(false);

	const firstName = profile?.fullname
		? profile.fullname.split(' ')[0]
		: 'John';

	const location = useLocation();
	const isProfilePage = location.pathname.includes('profile');

	const handleLogout = async () => {
		try {
			await logout();
			navigate('/login', { replace: true });
		} catch (error) {
			console.error('Logout failed');
			navigate('/login', { replace: true });
		}
	};
	const isGuest = profile?.rolename === 'guest';

	return (
		<>
			<header className={styles.header}>
				{/* 1. Mobile Menu Trigger & Logo (Visible only on Mobile) */}
				<div className={styles.mobileLeft}>
					<button className={styles.menuButton} onClick={onMenuClick}>
						<MenuIcon />
					</button>
					<img
						src={iocmLogo}
						alt="IOCM"
						className={styles.mobileLogo}
					/>
				</div>

				{/* 2. Desktop Title (Hidden on Mobile) */}
				<div className={styles.titleSection}>
					{isOverridden ? headerContent : <p>Welcome {firstName}</p>}
				</div>

				{!isProfilePage && (
					<div className={styles.headerActions}>
						<button className={styles.iconButton}>
							<SearchIcon />
						</button>

						<button className={styles.iconButton}>
							<BellIcon />
						</button>

						<button className={styles.iconButton}>
							<MailIcon />
						</button>

						{/* <button
							className={`${styles.iconButton} ${styles.desktopOnly}`}
						>
							<HelpIcon />
						</button> */}

						{/* Logout icon only for guest */}
						{isGuest && (
							<button
								className={styles.iconButton}
								onClick={() => setShowLogoutConfirm(true)}
							>
								<img src={iconlogout} alt="logout" width="18" />
							</button>
						)}
					</div>
				)}
			</header>
			{showLogoutConfirm && (
				<LogoutConfirmModal
					open={showLogoutConfirm}
					onConfirm={handleLogout}
					onCancel={() => setShowLogoutConfirm(false)}
				/>
			)}
		</>
	);
};

export default DashboardHeader;
